import { FaTiktok } from "react-icons/fa6";
import { type SocialPlatformBaseSettings } from "./types";

export const tiktokBaseSettings: SocialPlatformBaseSettings = {
  name: "TikTok",
  icon: FaTiktok,
  fields: {
    caption: "required",
    location: "optional",
    userTags: "optional",
    // Allow comments, duets, stitches are settings on platform
  },
  limits: {
    caption: 2200,
    images: 0, // Uses images for slideshows treated as video
    videos: 1,
    videoDurationSeconds: 10 * 60, // Max 10 mins (previously shorter)
    hashtags: 100, // Higher limit practical use varies
  },
  notes: [
    "Primarily short-form vertical video content.",
    "Can create slideshows from up to 35 images.",
  ],
  postTypes: {
    post: {}, // Default video post
  },
};
